import http from './http';
import Console from "../services/console";

export default {
  createCancelAttempt(cancelAttempt) {
    return http().post(`/v1/cancel_attempts`, cancelAttempt);
  },
  pauseAccount(days) {
    return http().put(`/v1/billing/pause`, {
      duration_in_days: days
    });
  },
  resumeAccount(data) {
    return http().put(`v1/billing/un_pause`, data);
  },
  addDiscount(couponCode) {
    return http().put(`/v1/billing/apply-coupon/${couponCode}`);
  },
  cancelAccount(accountId) {
    return http().delete(`/v1/billing/cancel`);
  },
}
